interface ColorSwatchProps {
    /** 色值 (#RRGGBB), 空则不画色块 */
    hex?: string;
    /** 颜色名 (字典文案); 为空时退回展示 hex */
    label?: string;
    /** 是否在颜色名后附带灰色 hex (详情页用, 列表页嫌挤不显示) */
    showHex?: boolean;
    /** 色块边长 px */
    size?: number;
}

/**
 * 颜色单元格: 色块 + 颜色名.
 * whitespace-nowrap 是关键 —— 材料列表 10 列时"颜色"列会被挤到 2 个字宽,
 * 中文没有单词边界, "蓝色"会断成"蓝/色"两行 (2026-08-26).
 */
const ColorSwatch = ({ hex, label, showHex = false, size = 14 }: ColorSwatchProps) => {
    const text = label || hex || '—';
    return (
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
            {hex && (
                <span
                    className="shrink-0"
                    style={{
                        width: size,
                        height: size,
                        borderRadius: 3,
                        border: '1px solid #cbd5e1',
                        background: hex,
                    }}
                />
            )}
            <span>{text}</span>
            {showHex && hex && label && (
                <span className="font-mono text-slate-400">{hex}</span>
            )}
        </span>
    );
};

export default ColorSwatch;
